/* eslint-disable jsx-a11y/no-autofocus */
import CN from 'classnames';
import { FC } from 'react';

export interface InputProps {
  className?: string | undefined;
  size?: 'md' | 'lg';
  inputClassName?: string;
  isAutoFocus?: boolean;
  isDisabled?: boolean;
  isError?: boolean;
  labelValue?: string | undefined;
  labelClassName?: string;
  onChange?: (e: any) => void | undefined;
  onKeyPress?: (e: any) => void | undefined;
  placeholder?: string;
  type?: string;
  value?: any;
  isRequired?: boolean;
  pattern?: string;
  icon?: string;
  isImgIcon?: boolean;
  appearance?: 'white' | 'gray';
  onclick?: any;
}

export const Input: FC<InputProps> = ({
  className = undefined,
  inputClassName = undefined,
  isAutoFocus = false,
  isDisabled = false,
  isError = false,
  labelValue = undefined,
  labelClassName = undefined,
  onChange = undefined,
  onKeyPress = undefined,
  placeholder = undefined,
  type = 'text',
  value = undefined,
  isRequired = false,
  pattern = undefined,
  icon = undefined,
  isImgIcon = false,
  appearance = 'white',
  size = 'md',
  onclick = undefined,
}: InputProps) => {
  return (
    <div className={CN('flex flex-col w-full captions-font', {}, className)}>
      {labelValue && (
        <span
          className={CN(
            'text-sm font-normal',
            {
              'text-[#737791] pb-1': !isError,
              'text-red-500 pb-1': isError,
            },
            labelClassName,
          )}
        >
          {labelValue}

          {isRequired && <span className="text-red-500 ml-[2px]">*</span>}
        </span>
      )}
      <div className={CN({ 'flex justify-center items-center relative': icon !== undefined })}>
        <input
          placeholder={placeholder}
          type={type}
          autoFocus={isAutoFocus}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyPress}
          className={CN(
            'w-full outline-none rounded-full py-[9px] px-4 placeholder:text-[#CCCCCC] disabled:text-neutral-500 disabled:cursor-not-allowed text-[#737791]',
            { 'border-red-600': isError },
            { '!pl-11 !pr-4': icon !== undefined },
            {
              'bg-white': appearance === 'white',
              'bg-[#F9FAFB]': appearance === 'gray',
              'text-base h-[50px]': size === 'md',
              'h-[56px] text-lg': size === 'lg',
            },
            inputClassName,
          )}
          disabled={isDisabled}
          pattern={pattern}
          onClick={onclick}
        />

        {icon &&
          (!isImgIcon ? (
            <i className={`${icon} absolute text-[20px] pl-4 left-0 text-[#CCCCCC]`} />
          ) : (
            <img
              src={icon}
              alt="input-icon"
              className="w-auto h-[20px] absolute text-[20px] pl-4 left-0 text-[#CCCCCC]"
            />
          ))}
      </div>
    </div>
  );
};

export default Input;
